import {
  getListNotificationParams,
  InitNotificationParams,
  UpdateDeviceStatusParams,
  UpdateNotificationStatusParams,
} from "./types";
import {
  getListNotificationURL,
  initNotification,
  updateNotificationStatusURL,
} from "./urls";
// import httpTrans from "core/http/singleton/notification";
import baseHttpService from "core/http/singleton/base";

export const postInitNotificationAPI = async (
  params: InitNotificationParams
): Promise<number> => {
  const res = await baseHttpService.post<number>(initNotification, params);
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};

export const updateStatusDeviceAPI = async (
  params: UpdateDeviceStatusParams
): Promise<any> => {
  const res = await baseHttpService.put(initNotification, params);
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};

export const getListNotificationAPI = async (
  params: getListNotificationParams
): Promise<any> => {
  const res = await baseHttpService.get(getListNotificationURL, params);
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};

export const updateStatusNotificationAPI = async (
  params: UpdateNotificationStatusParams
): Promise<any> => {
  const res = await baseHttpService.put(updateNotificationStatusURL, params);
  if (!res || !res.data) throw new Error("Opps");
  return res.data;
};
